import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  basePasswordInput: {
    color: '#2D2D2D',
    backgroundColor: '#fff',
    borderRadius: theme.spacing(2.5),
    transition: theme.transitions.create(['background-color', 'box-shadow']),
    paddingRight: theme.spacing(11.5),

    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },

    '& input': {
      padding: theme.spacing(10, 11.5, 10.5),

      '&::placeholder': {
        font: 'normal normal normal 14px/18px Roboto',
        color: '#C4C4C4',
        opacity: 1,
      },
    },

    [theme.breakpoints.down('sm')]: {
      '& input': {
        fontSize: theme.spacing(6),
        lineHeight: '14px',
        padding: theme.spacing(7.5, 8),
      },
    },
  },
  basePasswordInputFocused: {
    backgroundColor: '#fff !important',
    boxShadow: '0px 5px 10px #E0E4EE',
  },
  basePasswordInputFieldLabel: {
    display: 'flex',
    fontSize: theme.spacing(7),
    fontWeight: 400,
    lineHeight: '18px',
    color: '#000000',
    paddingBottom: theme.spacing(3),
    letterSpacing: 0,

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(4.5),
      lineHeight: '11px',
    },
  },
}));
